"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _hooks = require("../../hooks");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(slideBy) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    scrollProps = _useStylesUtils.scrollProps;
  var ccSwimLaneStyle = (0, _react.useMemo)(function () {
    var ccSwimLane = (0, _css.css)(_objectSpread({
      fontFamily: fontFamily,
      position: 'relative',
      paddingInlineEnd: pxToRem(64),
      overflowX: slideBy === 'scroll' ? 'auto' : 'unset'
    }, scrollProps(slideBy)));
    var ccArrowButtonWrapper = function ccArrowButtonWrapper(rotate) {
      return {
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        top: 0,
        bottom: 0,
        zIndex: 2,
        pointerEvents: 'none',
        marginBottom: pxToRem(55)
      };
    };
    var ccArrowLeftButtonWrapper = (0, _css.css)(_objectSpread(_objectSpread({}, ccArrowButtonWrapper(90)), {}, {
      left: 0
    }));
    var ccArrowRightButtonWrapper = (0, _css.css)(_objectSpread(_objectSpread({}, ccArrowButtonWrapper(270)), {}, {
      right: 0
    }));
    var ccArrowButtonContainer = (0, _css.css)({
      width: pxToRem(64),
      height: pxToRem(64)
    });
    var ccArrowButton = {
      background: '#ffffff 0% 0% no-repeat padding-box',
      boxShadow: "0 0 ".concat(pxToRem(7), " ").concat(pxToRem(3), " rgb(0 0 0 / 45%)")
    };
    var ccLeftArrowButton = _objectSpread(_objectSpread({}, ccArrowButton), {}, {
      transform: 'rotate(90deg)'
    });
    var ccRightArrowButton = _objectSpread(_objectSpread({}, ccArrowButton), {}, {
      transform: 'rotate(270deg)'
    });
    var ccArrowButtonContent = (0, _css.css)({
      width: '100%',
      height: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: pxToRem(70),
        height: pxToRem(70)
      }
    });
    var ccSwimLaneItems = (0, _css.css)({
      display: 'flex',
      overflowX: 'visible',
      transform: 'translateX(0)',
      transition: slideBy === 'item' ? 'transform 0.25s cubic-bezier(0.47, 0, 0.75, 0.72)' : 'transform 1s cubic-bezier(0.47, 0, 0.75, 0.72)'
    });
    var ccSwimLaneItem = (0, _css.css)({
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexShrink: 0,
      flexGrow: 0,
      marginInlineEnd: pxToRem(30)
    });
    return {
      ccSwimLane: ccSwimLane,
      ccArrowLeftButtonWrapper: ccArrowLeftButtonWrapper,
      ccArrowRightButtonWrapper: ccArrowRightButtonWrapper,
      ccArrowButtonContainer: ccArrowButtonContainer,
      ccLeftArrowButton: ccLeftArrowButton,
      ccRightArrowButton: ccRightArrowButton,
      ccArrowButtonContent: ccArrowButtonContent,
      ccSwimLaneItems: ccSwimLaneItems,
      ccSwimLaneItem: ccSwimLaneItem
    };
  }, [slideBy, fontFamily, pxToRem, scrollProps]);
  return {
    'cc-SwimLane': ccSwimLaneStyle.ccSwimLane,
    'cc-SwimLane__button-left-wrapper': ccSwimLaneStyle.ccArrowLeftButtonWrapper,
    'cc-SwimLane__button-right-wrapper': ccSwimLaneStyle.ccArrowRightButtonWrapper,
    'cc-SwimLane__button-container': ccSwimLaneStyle.ccArrowButtonContainer,
    'cc-SwimLane__button-left': ccSwimLaneStyle.ccLeftArrowButton,
    'cc-SwimLane__button-right': ccSwimLaneStyle.ccRightArrowButton,
    'cc-SwimLane__button-content': ccSwimLaneStyle.ccArrowButtonContent,
    'cc-SwimLane__items': ccSwimLaneStyle.ccSwimLaneItems,
    'cc-SwimLane__item': ccSwimLaneStyle.ccSwimLaneItem
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;